import {Component, OnInit, OnDestroy, ElementRef, ViewChild} from '@angular/core';
import * as pbi from 'powerbi-client';
import {Subscription} from 'rxjs';
import {environment} from 'src/environments/environment';
import {AuthorizationService} from "../service/authorization.service";
import {ActivatedRoute} from "@angular/router";
import {AuthService} from "@auth0/auth0-angular";

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit, OnDestroy {

  report: pbi.Embed | undefined;
  @ViewChild('reportContainer', {static: false}) reportContainer: ElementRef | undefined;

  tokenSubscription: Subscription | undefined;

  navOpen = true;

  groupId: string = "";
  name: string = "";
  tokens: any[] = []

  activeReport: number = 0

  requestedReports: Set<number> = new Set([0]);

  constructor(private authorizationService: AuthorizationService, private _Activatedroute: ActivatedRoute, private auth: AuthService) {
  }

  public powerbi = new pbi.service.Service(pbi.factories.hpmFactory,
    pbi.factories.wpmpFactory,
    pbi.factories.routerFactory);

  ngOnInit() {
    this._Activatedroute.paramMap.subscribe(params => {
      const report_key = params.get('name') ?? '';
      const reportConfig = environment.reports.get(report_key);
      console.warn('[pbi-embed] opening report', {
        reportKey: report_key,
        knownReports: Array.from(environment.reports.keys()),
        groupId: reportConfig?.groupId,
        authorizer: environment.authorizerServiceUrl
      });
      // @ts-ignore
      this.groupId = reportConfig.groupId;
      // @ts-ignore
      this.name = reportConfig.name;
      this.embedReport();
    })
  }

  embedReport() {
    this.tokenSubscription = this.authorizationService.getReportEmbedToken(this.groupId)
      .subscribe((response) => {
          console.warn('[pbi-embed] token response', {
            groupId: this.groupId,
            count: response?.length,
            reports: response?.map((token, index) => ({
              index,
              name: token.name,
              embedUrl: token.embeddedUrl,
              embedUrlFlags: embedUrlFlags(token.embeddedUrl),
              tokenLength: token.embeddedToken?.length ?? 0,
              claims: embedTokenClaims(token.embeddedToken)
            }))
          });

          let index = 0
          response.forEach(token => {
            const config = {
              type: 'report',
              tokenType: pbi.models.TokenType.Embed,
              embedUrl: token.embeddedUrl,
              accessToken: token.embeddedToken,
              name: token.name,
              index: index++         
            };
            this.tokens.push(config)
          })
        },
        (error) => {
          console.error('[pbi-embed] token request failed', {
            groupId: this.groupId,
            status: error?.status,
            url: error?.url,
            message: error?.message,
            body: error?.error
          });
          this.navigateToErrorPage();
        });
  }

  handleNavOpenChange(event: any & { detail: boolean }): void {
    this.navOpen = event.detail;
  }

  changeReport(index: number) {
    this.requestedReports.add(index)
    this.activeReport = index;
  }

  navigateToErrorPage() {
    window.location.href = environment.forbiddenErrorUrl;
  }

  ngOnDestroy(): void {
    if (this.tokenSubscription) {
      this.tokenSubscription.unsubscribe();
    }
  }

  isInRequestedReports(index: number): boolean {
    return this.requestedReports.has(index);
  }
}

function embedUrlFlags(embedUrl: string | undefined) {
  const url = embedUrl ?? '';
  return {
    reportEmbed: url.includes('reportEmbed'),
    rdlEmbed: url.toLowerCase().includes('rdlembed'),
    autoAuth: decodeURIComponent(url).toLowerCase().includes('autoauth=true'),
    ctid: new URLSearchParams(url.split('?')[1] ?? '').get('ctid')
  };
}

function embedTokenClaims(token: string | undefined) {
  if (!token) {
    return null;
  }
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const claims = JSON.parse(atob(payload));
    return {
      exp: claims.exp,
      workspaceId: claims.wid ?? claims.wcn,
      reportId: claims.rid,
      datasetId: claims.did,
      roles: claims.roles,
      identities: claims.identities
    };
  } catch (error) {
    return { decodeError: String(error), tokenLength: token.length };
  }
}
